import { createTranslationFile, createLanguage } from "@vocab/core/runtime";
const translations = createTranslationFile({
  en: createLanguage({ Location: "Location" }),
  th: createLanguage({ Location: "ภูมิภาค" }),
  id: createLanguage({ Location: "Lokasi" }),
  zh: createLanguage({ Location: "地點" }),
  "en-AU": createLanguage({ Location: "Location" }),
  "en-HK": createLanguage({ Location: "Location" }),
  "en-ID": createLanguage({ Location: "Location" }),
  "en-MY": createLanguage({ Location: "Location" }),
  "en-NZ": createLanguage({ Location: "Location" }),
  "en-PH": createLanguage({ Location: "Location" }),
  "en-SG": createLanguage({ Location: "Location" }),
  "en-TH": createLanguage({ Location: "Location" }),
  "th-TH": createLanguage({ Location: "ภูมิภาค" }),
  "id-ID": createLanguage({ Location: "Lokasi" }),
  "zh-HK": createLanguage({ Location: "地點" }),
  "en-PSEUDO": createLanguage({ Location: "[Łööçăăṯììööกี้]" })
});
export {
  translations
};
